export default __webpack_public_path__ + "static/media/image2.49b198cd.png";